import React from "react";

export interface IErrorFieldsContext {
    errorFields: any[];
    additionalErrorFields: any[];
}

export const ErrorFieldsContext = React.createContext<IErrorFieldsContext>({
    errorFields: new Array(),
    additionalErrorFields: new Array()
});
